module.exports = __webpack_public_path__ + "fonts/Quicksand-500-vietnamese7.acc5504.woff2";